import PropTypes from 'prop-types';
import { omitBy, isNil } from 'lodash/fp';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import SidebarContainer from '../SidebarContainer';
import feedMappingsActions from '../../redux/feedMappings/actions';
import ContentPage from '../ContentPage';
import ErrorMessage from '../../components/ErrorMessage';
import './FeedMapping.scss';

import {
  FeedMappingEditor,
  NewFeedMapping,
} from '../../components/FeedMappingEditor';

class FeedMapping extends Component {
  componentDidMount() {
    const { feedMappingId } = this.props.match.params;
    if (feedMappingId) {
      this.props.actions.feedMappingRequest(feedMappingId);
    } else {
      this.props.actions.resetFeedMapping(feedMappingId);
    }
  }

  onCreate = (params) => {
    this.props.actions.createFeedMappingRequest(params);
  };

  onUpdate = (feed) => {
    this.props.actions.updateFeedMappingRequest(feed);
  };

  render() {
    const { feedMappings } = this.props;
    const { error, fetching } = feedMappings;
    // nulls are invalid in JSON schema
    const feedMapping = omitBy(isNil)(feedMappings.feedMapping);
    return (
      <SidebarContainer>
        <div className="feed-mapping-table">
          {error && <ErrorMessage error={error} />}
          {feedMapping.id && (
            <FeedMappingEditor
              feedMapping={feedMapping}
              fetching={fetching}
              onUpdate={this.onUpdate}
            />
          )}
          {!feedMapping.id && (
            <NewFeedMapping
              feedMapping={feedMapping}
              fetching={fetching}
              onCreate={this.onCreate}
            />
          )}
        </div>
      </SidebarContainer>
    );
  }
}

FeedMapping.propTypes = {
  match: PropTypes.object,
  actions: PropTypes.object,
  feedMappings: PropTypes.object,
};

const mapStateToProps = ({ feedMappings }) => ({
  feedMappings,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...feedMappingsActions,
    },
    dispatch,
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContentPage(FeedMapping));
